export default __webpack_public_path__ + "static/media/newbane.e09d4268.png";